<template>
    <div id="app" class="outer">
        <div class="inner">
            <template v-if="processing">
                Checking Code...
            </template>
            <template v-else>
                <h1>{{message}}</h1>
                <form @submit.prevent.stop="submit()">
                    <input autofocus type="password" pattern="[0-9]*" inputmode="numeric" v-model="model.pin" placeholder="Enter your pin" />
                    <div class="keypad">
                        <div class="row">
                            <a @click="press(1)">1</a>
                            <a @click="press(2)">2</a>
                            <a @click="press(3)">3</a>
                        </div>
                        <div class="row">
                            <a @click="press(4)">4</a>
                            <a @click="press(5)">5</a>
                            <a @click="press(6)">6</a>
                        </div>
                        <div class="row">
                            <a @click="press(7)">7</a>
                            <a @click="press(8)">8</a>
                            <a @click="press(9)">9</a>
                        </div>
                        <div class="row">
                            <a @click="backspace()" class="backspace" :disabled="!model.pin">
                                <font-awesome-icon :icon="['fal', 'backspace']" /></a>
                            <a @click="press(0)">0</a>
                            <button type="submit" class="submit" :disabled="!ready">
                                <font-awesome-icon :icon="['fal', 'check']" />
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </div>
    </div>
</template>
<script>
////////////////////////////////////////////////////////

import axios from 'axios';

export default {

    data() {
        return {
          processing:false,
            model: {
                pin: '',
            },
            message: 'This application is locked. Please enter your application PIN to continue.',
        }
    },
    computed: {
        ready() {
            return this.model.pin && (this.model.pin.length >= 4)
        }
    },
    methods: {
        backspace() {
            if (!this.model.pin || !this.model.pin.length) {
                return this.model.pin = '';
            }
            this.model.pin = this.model.pin.slice(0, -1)
        },
        press(digit) {
            this.model.pin = `${this.model.pin}${digit}`;
        },

        submit() {

            console.log('SUBMIT')
            var self = this;
            self.processing = true;
            axios.post(`/pin`, {
                    pin: self.model.pin
                })
                .then(function(res) {

                    console.log('RESPONSE', res);
                    window.location.replace('/')
                })
                .catch(function(err) {
                    console.log('ERROR', err);
                    self.processing = false;
                })
        }
    },

}
</script>
<style lang="scss">
.outer {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;
    font-family: sans-serif;
}

.inner {
    padding: 15px;
    text-align: center;
    max-width: 400px;
}

h1 {
    font-size: 1em;
}

button, a {
    border: none;
    appearance: none;
    background: rgba(#000, 0.05);
    font-size: clamp(10px, 7vw, 30px);
    margin: 2px;
    border-radius: 2px;
    font-weight: bold;

    &.submit {
        background: #6378f6;
        color: #fff;
    }

    &.backspace {
        color: rgba(#000, 0.5);
    }
}


input {
    width: 100%;
    line-height: 50px;
    font-size: 30px;
    border: 1px solid rgba(#000, 0.1);
    height: 50px;
    text-align: center;
}

.keypad {
    .row {
        display: flex;
    }

    button, a {
        height: 100%;
        width: 100%;
        padding: 15px 0;
        text-align: center;

        &:disabled {
            opacity: 0.3;
            background: rgba(#000, 0.05) !important;
            color: inherit !important;
        }
    }
}
</style>